<template>
  <v-card>
    <v-toolbar dark color="#06377a">
      <v-toolbar-title>
        Detail Material
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn class="mr-1" icon dark @click="closeDialog()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pt-5">
      <v-row>
        <v-col cols="6" class="pl-5">
          <div style="display: flex">
            <v-file-input
              v-model="attachment"
              ref="attachment"
              chips
              show-size
              multiple
              prepend-icon="mdi-file-upload"
              label="Choose File Upload"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsx, .xls, .pdf, .jpg, .png, .jpeg, .doc, .docx"
            ></v-file-input>

            <v-btn
              dark
              depressed
              color="primary"
              class="ml-3 mt-5"
              @click="uploadFiles()"
              :loading="loadingUpload"
            >
              Upload
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12">
          <div>
            <MaterialFile
              v-if="!loadingUpload"
              :request_no="data.request_no"
              :material_number="data.material_number"
            ></MaterialFile>

            <div v-else>
              <v-skeleton-loader
                v-bind="attrs"
                type="image"
              ></v-skeleton-loader>
            </div>
          </div>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="12" md="6">
          <v-simple-table class="table">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td width="200">Request No.</td>
                  <td class="bold">{{ data.request_no }}</td>
                </tr>
                <tr>
                  <td>Requester.</td>
                  <td class="bold">{{ data.request_by }}</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td class="bold">
                    <status :status="data.status"></status>
                  </td>
                </tr>
                <tr>
                  <td>Material No.</td>
                  <td class="bold">
                    {{ data.material_number || "-" }}
                  </td>
                </tr>
                <tr>
                  <td>Old Material No.</td>
                  <td class="bold">
                    {{ data.old_material_number || "-" }}
                  </td>
                </tr>
                <tr>
                  <td>Item Name</td>
                  <td class="bold">{{ data.inc_name || "-" }}</td>
                </tr>
                <tr>
                  <td>INC Code</td>
                  <td class="bold">{{ data.inc_code || "-" }}</td>
                </tr>
                <tr>
                  <td>Item Description</td>
                  <td class="bold">
                    <div style="word-break:break-all">
                      {{ data.description }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Basic Data Text</td>
                  <td class="bold">
                    <div
                      style="word-break:break-all"
                      v-html="basic_data_text_format || '-'"
                    ></div>
                  </td>
                </tr>
                <tr>
                  <td>Colloquial Name</td>
                  <td class="bold">{{ data.colloquial_name || "-" }}</td>
                </tr>
                <tr>
                  <td>Manufacturer</td>
                  <td class="bold">
                    {{ data.manufacturer }} - {{ data.manufacturer_name }}
                  </td>
                </tr>
                <tr>
                  <td>Part Number</td>
                  <td class="bold">
                    {{ data.part_number }}
                    <span v-if="!data.part_number">-</span>
                  </td>
                </tr>
                <tr>
                  <td>Automatic PO</td>
                  <td class="bold">
                    <v-icon v-if="data.automatic_po === 'X'" color="success">
                      mdi-check-circle
                    </v-icon>

                    <v-icon v-else color="error">
                      mdi-close-circle
                    </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>Source List</td>
                  <td class="bold">
                    <v-icon v-if="data.source_list === 'X'" color="success">
                      mdi-check-circle
                    </v-icon>

                    <v-icon v-else color="error">
                      mdi-close-circle
                    </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>Purchasing Group</td>
                  <td class="bold">
                    {{ data.purchasing_group }} -
                    {{ data.purchasing_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>Purchasing Value Key</td>
                  <td class="bold">
                    {{ data.purchasing_value_key }} -
                    {{ data.purchasing_value_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Group</td>
                  <td class="bold">
                    {{ data.mrp_group }} - {{ data.mrp_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Type</td>
                  <td class="bold">
                    {{ data.mrp_type }} - {{ data.mrp_type_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Control</td>
                  <td class="bold">
                    {{ data.mrp_control }} - {{ data.mrp_control_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Profile</td>
                  <td class="bold">
                    {{ data.mrp_profile }} - {{ data.mrp_profile_name }}
                  </td>
                </tr>
                <tr>
                  <td>Remarks</td>
                  <td class="bold">
                    {{ data.remarks }}
                    <span v-if="!data.remarks">-</span>
                  </td>
                </tr>

                <tr>
                  <td width="200">Request Date</td>
                  <td class="bold">{{ data.request_date }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="12" md="6">
          <v-simple-table class="table">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td width="200">Plant</td>
                  <td class="bold">{{ data.plant }} - {{ data.plant_name }}</td>
                </tr>
                <tr>
                  <td>Industry Sector</td>
                  <td class="bold">
                    {{ data.industry_sector }} {{ data.industry_sector_name }}
                  </td>
                </tr>
                <tr>
                  <td>Material Type</td>
                  <td class="bold">
                    {{ data.material_type }} -
                    {{ data.material_type_name }}
                  </td>
                </tr>
                <tr>
                  <td>Base Unit</td>
                  <td class="bold">
                    {{ data.base_unit }} - {{ data.base_unit_name }}
                  </td>
                </tr>
                <tr>
                  <td>Order Unit</td>
                  <td class="bold">
                    {{ data.order_unit !== "null" ? data.order_unit : "" }} -
                    {{
                      data.order_unit_name !== "null"
                        ? data.order_unit_name
                        : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Division</td>
                  <td class="bold">
                    {{ data.division }} - {{ data.divisi_name }}
                  </td>
                </tr>
                <tr>
                  <td>Material Group</td>
                  <td class="bold">
                    {{ data.material_group }} - {{ data.material_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>External Group</td>
                  <td class="bold">
                    {{ data.external_group }} - {{ data.external_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>Lab/Office</td>
                  <td class="bold">
                    {{ data.lab_office }} - {{ data.lab_office_name }}
                  </td>
                </tr>
                <tr>
                  <td>Basic Material</td>
                  <td class="bold">
                    {{ data.basic_material }} - {{ data.basic_material }}
                  </td>
                </tr>
                <tr>
                  <td>Lot Size Procedure</td>
                  <td class="bold">
                    {{ data.lot_size_procedure }} -
                    {{ data.lot_size_procedure_name }}
                  </td>
                </tr>
                <tr>
                  <td>Procurement Type</td>
                  <td class="bold">
                    {{ data.proc_type }} - {{ data.proc_type_name }}
                  </td>
                </tr>
                <tr>
                  <td>Special Proc.</td>
                  <td class="bold">
                    {{ data.special_proc }} - {{ data.special_proc_name }}
                  </td>
                </tr>
                <tr>
                  <td>Planned Delivery Time</td>
                  <td class="bold">{{ data.planned_delivery_time }} Days</td>
                </tr>
                <tr>
                  <td>Availibility Check</td>
                  <td class="bold">
                    {{ data.availibility_check }} -
                    {{ data.availibility_check_name }}
                  </td>
                </tr>
                <tr>
                  <td>Valuation Category</td>
                  <td class="bold">
                    {{ data.valuation_category }} -
                    {{ data.valuation_category_name }}
                  </td>
                </tr>
                <tr>
                  <td>Valuation Type</td>
                  <td class="bold">
                    {{ data.valuation_type || "-" }}
                  </td>
                </tr>
                <tr>
                  <td>Valuation Class</td>
                  <td class="bold">
                    {{ data.valuation_class }} - {{ data.valuation_class_name }}
                  </td>
                </tr>
                <tr>
                  <td>Price Control</td>
                  <td class="bold">
                    {{ data.price_control }} - {{ data.price_control_name }}
                  </td>
                </tr>
                <tr>
                  <td>Request Type</td>
                  <td class="bold">
                    {{ data.type_input === "NEW" ? "New" : "Extend" }}
                  </td>
                </tr>
                <tr>
                  <td>Storage Location</td>
                  <td class="bold">
                    {{
                      data.storage_location !== "null"
                        ? data.storage_location
                        : "-"
                    }}

                    {{
                      data.storage_location_name !== "null"
                        ? data.storage_location_name
                        : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Price</td>
                  <td class="bold">
                    <div v-if="data.price_item" style="font-weight: bold;">
                      IDR
                      {{
                        data.price_item.toLocaleString().replace(/[,]/g, ".")
                      }}
                    </div>
                    <div v-else>
                      <v-btn
                        depressed
                        x-small
                        style="color: #FF7043"
                        color="#FBE9E7"
                      >
                        Need Price Information
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </tbody>

              <v-snackbar
                v-model="snackbar.open"
                :timeout="snackbar.timeout ? snackbar.timeout : 7000"
                top
              >
                {{ snackbar.message_text }}

                <template v-slot:action="{ attrs }">
                  <v-btn
                    :color="
                      snackbar.button_type ? snackbar.button_type : 'primary'
                    "
                    v-bind="attrs"
                    @click="snackbar.open = false"
                  >
                    {{ snackbar.button_text ? snackbar.button_text : "Close" }}
                  </v-btn>
                </template>
              </v-snackbar>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import StatusVue from "../component/Status.vue"
import MaterialFile from "@/modules//component/MaterialFile.vue"

export default {
  components: {
    status: StatusVue,
    MaterialFile,
  },
  data() {
    return {
      name: "DetailMaterial",
      title: "Detail Material",
      data: null,
      loadingUpload: false,
      snackbar: {
        open: false,
        message_text: null,
        button_type: "primary",
        button_text: "Close",
        timeout: 3000,
      },
      storage_user_id: atob(localStorage.getItem("user_id")),
    }
  },

  computed: {
    basic_data_text_format() {
      return this.data.basic_data_text.replace(/[;]/g, "<br />")
    },
  },

  mounted() {
    this.getMaterial()
  },
  methods: {
    getMaterial() {
      const self = this
      const id = this.$attrs.data.id
      const url = this.base_url + "material/getdata/detail/" + id

      this.axios.get(url).then(function(response) {
        self.data = response.data
      })
    },

    uploadFiles() {
      if (this.attachment.length === 0) {
        return
      }
      var self = this

      var request_no = this.data.request_no
      let formData = new FormData()
      self.loadingUpload = true

      self.attachment.forEach((file, index) => {
        let name = self.storage_user_id + "-" + file.name
        formData.append(`file${index}`, file)
        formData.append(`filename${index}`, name)
      })

      const filenames = self.attachment.map((file) => file.name)
      formData.append("filenames", JSON.stringify(filenames))
      formData.append("request_number", request_no)
      formData.append("user_id", self.storage_user_id)

      var url = self.base_url + "material/upload/files"
      self.axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          self.loadingUpload = false
          self.attachment = []

          self.snackbar = {
            open: true,
            message_text: "Material upload has been successful",
            button_type: "primary",
            button_text: "Ok",
          }
        })
        .catch((error) => {
          self.loadingUpload = false

          self.snackbar = {
            open: true,
            message_text: "Material file upload failed",
            button_type: "red",
            button_text: "Ok",
          }

          console("Error upload file" + error)
        })
    },

    closeDialog() {
      this.$emit("closeDialog")
    },
  },
}
</script>

<style>
.bold {
  font-weight: 600 !important;
}

.table tr:hover {
  background: #fafafa !important;
}
</style>
